<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium">
      {{ 'stages.move_stage.field' | translate }}
    </label>
    <p-tree
      [value]="treeNodes"
      selectionMode="single"
      [selection]="selectedNode()"
      (onNodeSelect)="onNodeSelect($event)"
      (onNodeUnselect)="onNodeUnselect($event)"
      styleClass="w-full border-none"
    >
      <ng-template let-node pTemplate="default">
        @if (node.data.type === 'root') {
          <span class="italic">{{ 'stages.move_stage.projectRoot' | translate }}</span>
        } @else if (node.selectable === false) {
          <span
            class="flex items-center gap-2 text-surface-400 dark:text-surface-600 cursor-not-allowed"
            [pTooltip]="'stages.move_stage.disabledTooltip' | translate"
            tooltipPosition="right"
          >
            {{ node.label }}
            <i class="fa-solid fa-ban text-xs"></i>
          </span>
        } @else {
          <span>{{ node.label }}</span>
        }
      </ng-template>
    </p-tree>
  </div>

  <p class="text-sm text-surface-600 dark:text-surface-400">
    {{
      (currentParentName() === null ? 'stages.move_stage.currentLocationRoot' : 'stages.move_stage.currentLocation')
        | translate: { stageName: movingStage.name, parentName: currentParentName() }
    }}
  </p>

  @if (hasChanged()) {
    <p-message severity="info" styleClass="w-full">
      {{
        (selectedIsRoot() ? 'stages.move_stage.confirmNoteRoot' : 'stages.move_stage.confirmNote')
          | translate: { parentName: selectedTargetName() }
      }}
    </p-message>
  }

  <div class="flex justify-end gap-2 mt-2">
    <p-button
      [label]="'button.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="cancel()"
    />
    <p-button
      [label]="'button.confirm' | translate"
      [disabled]="!hasChanged()"
      (onClick)="confirm()"
    />
  </div>
</div>
